import React from "react";
import { Crown, Target, TrendingUp, RotateCcw, Trophy, Gift } from "lucide-react";
import { features } from "../mock";

const iconMap = { Crown, Target, TrendingUp, RotateCcw, Trophy, Gift };

const FeatureGrid = () => {
  return (
    <div className="max-w-6xl mx-auto w-full px-4 sm:px-6 py-12" data-testid="home-feature-grid">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {features.map((f, i) => {
          const Icon = iconMap[f.icon] || Gift;
          return (
            <div
              key={f.id}
              data-testid={`home-feature-${f.id}`}
              className="group relative overflow-hidden rounded-2xl glass p-6 transition-all hover:-translate-y-1 hover:ring-1 hover:ring-emerald-400/40"
            >
              <div>
                <div className="flex items-center justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-500/15 ring-1 ring-emerald-400/25 text-emerald-300">
                    <Icon className="h-6 w-6" />
                  </span>
                  <span className="text-[10px] uppercase tracking-widest text-emerald-400/70">
                    {f.tag}
                  </span>
                </div>
                <h3 data-testid={`home-feature-title-${f.id}`} className="mt-5 font-display text-xl font-bold text-white">
                  {f.title}
                </h3>
                <p data-testid={`home-feature-description-${f.id}`} className="mt-2 text-sm leading-relaxed text-slate-400">
                  {f.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeatureGrid;
